import { render, staticRenderFns } from "./TeamListComponent.vue?vue&type=template&id=ded47e12&"
import script from "./TeamListComponent.vue?vue&type=script&lang=js&"
export * from "./TeamListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports